import Columnizer from './Columnizer';
export default Columnizer;